import { Box, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { getMessageColorSchema } from 'components'
import { Message } from 'lib/apiClient'
import { MessageDate, TextMessage } from 'components/ChatMessage/components'
import { useProcessDebugDetailsContext } from 'pages/AiProcessDebugV2/hooks/useProcessDebugDetailsContext'
import { FixedPromptTextGeneration } from 'pages/AiProcessDebugV2/components/FixedPromptTextGeneration/FixedPromptTextGeneration'

import { CollapsibleChatMessage } from '../CollapsibleChatMessage'
import { DebugChatMessageLayout } from './DebugChatMessageLayout'

interface CollapsibleDebugChatMessageProps {
  message: Message
  isSelected?: boolean
  onClick?: () => void
}

export const CollapsibleDebugChatMessage: FC<CollapsibleDebugChatMessageProps> = ({
  message,
  onClick,
  isSelected,
}) => {
  const { fixedPromptTextGenerationsCount } = useProcessDebugDetailsContext()

  const colorSchema = getMessageColorSchema({
    messageType: message.authorRole,
    isDebugView: true,
  })

  return (
    <DebugChatMessageLayout
      message={message}
      colorSchema={colorSchema}
      onClick={onClick}
      isSelected={isSelected}
    >
      <VStack space="s-4">
        <CollapsibleChatMessage
          label="Original"
          collapsible={Boolean(fixedPromptTextGenerationsCount)}
        >
          <Box display="inline-table">
            <TextMessage text={message.text} colorSchema={colorSchema} />
            <MessageDate createdAt={message.created} colorSchema={colorSchema} />
          </Box>
        </CollapsibleChatMessage>
        <FixedPromptTextGeneration createdAt={message.created} />
      </VStack>
    </DebugChatMessageLayout>
  )
}
